module.exports = __webpack_public_path__ + "static/img/logo.c703c49e.png";